import { ReactNode } from 'react';
import cn from 'classnames';
import { UiTitle, UiIcon, UiText } from '@frontend/znanie-uikit';

import css from './InfoMessage.module.scss';

interface IProps {
  text: string | ReactNode;
  iconName?: TIconName;
  withoutIcon?: boolean;
  children?: ReactNode;
  className?: string;
  titleClass?: string;
}

interface IContent {
  children: ReactNode;
  className?: string;
}

interface IActions extends IContent {
  isSingleAction?: boolean;
  actionsClass?: string;
}

type TIconName = 'success' | 'warning' | 'question';

export default function InfoMessage({
  text,
  className,
  titleClass,
  iconName = 'success',
  withoutIcon = false,
  children,
}: IProps) {
  return (
    <div className={cn(css.block, className)}>
      {!withoutIcon && <UiIcon name={iconName} width={70} height={70} />}
      <UiTitle
        className={cn(css.title, titleClass, {
          [css.withoutIcon]: withoutIcon,
        })}
        align="center"
        size="large"
      >
        {text}
      </UiTitle>
      {children}
    </div>
  );
}

function Content({ children }: IContent) {
  return <div className={css.content}>{children}</div>;
}

function Description({ children, className }: IContent) {
  return (
    <UiText
      className={cn(css.description, className)}
      align="center"
      size="small"
      color="grey"
    >
      {children}
    </UiText>
  );
}

function Actions({ children, isSingleAction, className }: IActions) {
  const styles = cn(
    css.actions,
    { [css.doubleActions]: !isSingleAction },
    className
  );
  return <div className={styles}>{children}</div>;
}

InfoMessage.Content = Content;
Content.Description = Description;
Content.Actions = Actions;
